<template>
  <!-- 底层绝对定位，禁止上下滑动 -->
  <div @click="play" v-show="school" :style="{position: 'fixed', width: width + 'px', height: height + 'px'}">
    <template v-if="$store.state.data.gifTime && !gifFinish">
      <!-- gif  @load='gifState' @error='gifState' -->
      <img v-if="gifLoaded" class="gif" id="gif" :src="`${$store.state.data.baseUrl}/welcome.gif`" />
      <img v-else class="gif" id="gif" :src="`${$store.state.data.baseUrl}/welcome.png`" />
    </template>
    <div v-show="!($store.state.data.gifTime && !gifFinish)">
      <!-- 背景音乐 西交大口腔去掉背景音乐 -->
      <template v-if="$store.state.id != 25">
        <div v-if="$store.state.data.type == 21 && $store.state.id != 22" class="audio21" @click="audioTap" :style="globe ? '' : 'display: none;'">
          <img v-if="playing" class="audio-bg" src="@/assets/images/audio_play.png" alt="">
          <img v-else class="audio-bg" src="@/assets/images/audio_pause.png" alt="">
          <audio :autoplay="$store.state.id != 26" loop :src="`${$store.state.data.baseUrl}/bg_music.mp3`" id='audio' ref='audio'></audio>
        </div>
        <div v-else :class="`audio ${playing ? 'playing' : ''}`" @click="audioTap">
          <img class="audio-bg" v-if="playing" src="@/assets/images/music_play.png" alt="">
          <img class="audio-bg" v-else src="@/assets/images/music_pause.png" alt="">
          <audio :autoplay="$store.state.id != 26" loop :src="`${$store.state.data.baseUrl}/bg_music.mp3`" id='audio' ref='audio'></audio>
        </div>
      </template>

      <!-- 页面背景 -->
      <img class="globebg" :class="{ 'globebg-30': $store.state.data.type == 30 }" :src="`${$store.state.data.baseUrl}/bg3.png`" alt="">
      <!-- 地图、统计 -->
      <div v-if="!globe" class="main">
        <!-- 21 中国劳动关系学院、30 重庆医科 单独顶部按钮 -->
        <div v-if="$store.state.data.type == 21 || $store.state.data.type == 30" class="topButton" :class="{ 'topButton30': $store.state.data.type == 30 }" @click="topSelect">
          <!-- 北师大不展示世界地图 -->
          <div>
            <img :src="`${$store.state.data.baseUrl}/${select === 0 ? 'map_globe_selected.png' : 'map_globe.png'}`" alt="">
            <p style="opacity: 0;">全球地图</p>
          </div>
          <!-- 北师大不展示全国地图 -->
          <div>
            <img :src="`${$store.state.data.baseUrl}/${select === 1 ? 'map_china_selected.png' : 'map_china.png'}`" alt="">
            <p style="opacity: 0;">全国地图</p>
          </div>
          <div>
            <img :src="`${$store.state.data.baseUrl}/${select === 2 ? 'statistics_button_selected.png' : 'statistics_button.png'}`" alt="">
            <p style="opacity: 0;">统计</p>
          </div>
        </div>
        <!-- 农大不展示 -->
        <div v-else-if="$store.state.id == 26" class="topButton"></div>
        <div v-else class="topButton" @click="topSelect">
          <!-- 北师大不展示世界地图 -->
          <div v-if="$store.state.id != 8">
            <img :src="`${$store.state.data.baseUrl}/${select === 0 ? 'statistics_button_select_bg.png' : 'statistics_button_bg.png'}`" alt="">
            <p>全球地图</p>
          </div>
          <!-- 北师大不展示全国地图 -->
          <div v-if="$store.state.id != 8">
            <img :src="`${$store.state.data.baseUrl}/${select === 1 ? 'statistics_button_select_bg.png' : 'statistics_button_bg.png'}`" alt="">
            <p>全国地图</p>
          </div>
          <div>
            <img :src="`${$store.state.data.baseUrl}/${select === 2 ? 'statistics_button_select_bg.png' : 'statistics_button_bg.png'}`" alt="">
            <p>统计</p>
          </div>
        </div>
        <!-- 32 首经贸单独设置底部按钮样式 -->
        <div v-if="$store.state.id == 32" class="bottomButton32">
          <div class="share" @click="shareTap">
             <img class="img" :src="`${$store.state.data.baseUrl}/save_tips_button.png`" alt="">
          </div>
          <div class="back" @click="backTap">
             <img class="img" :src="`${$store.state.data.baseUrl}/back_mini_button.png`" alt="">
          </div>
        </div>
        <!-- 北师大单独设置底部按钮样式 -->
        <div v-else :class="($store.state.id == 26 || $store.state.data.type == 30) ? 'bottomButton26' : 'bottomButton'" :style="$store.state.id == 8 ? 'bottom: 0.65rem;' : ''">
          <div class="back" @click="backTap">
             <img :class="$store.state.id == 8 ? 'beishida-img' : 'img'" :src="`${$store.state.data.baseUrl}/${ ($store.state.id == 26 || $store.state.data.type == 30) ? 'statistics_back' : 'back_bg' }.png`" alt="">
             <p :class="$store.state.id == 8 ? 'beishida-title' : ''">{{ $store.state.data.type == 21 ? '' : '返回' }}</p>
          </div>
          <!-- 广州医科大学单独分享样式 -->
          <div class="share" @click="$store.state.data.type == 9 ?  showYikeShareTip = !showYikeShareTip : showShareTip = !showShareTip">
             <img :class="$store.state.id == 8 ? 'beishida-img' : 'img'" :src="`${$store.state.data.baseUrl}//${ ($store.state.id == 26 || $store.state.data.type == 30) ? 'statistics_bg_share' : 'share_bg' }.png`" alt="">
             <p :class="$store.state.id == 8 ? 'beishida-title' : ''">{{ $store.state.data.type == 21 ? '' : '分享' }}</p>
          </div>
        </div>
        <!-- 广州医科大学单独分享引导 -->
        <div class="yike-share-tip"
             v-show="showYikeShareTip"
             @click="showYikeShareTip = !showYikeShareTip; showYikePoster = !showYikePoster">
             <img :src="`${$store.state.data.baseUrl}/share_handle.png`" alt="">
             <div v-if="!showYikePoster" class="yike-button">
              <div class="yike-poster" @click.stop="showYikePoster = !showYikePoster">生成海报</div>
              <div class="yike-share yike-poster" @click="showShareTip = !showShareTip">分享点亮</div>
             </div>
             <div v-if="showYikePoster" class="yike-button">
               <div class="yike-poster" style="width: 100%; text-align: center;">长按保存海报</div>
             </div>
        </div>
        <!-- 分享引导 -->
        <div v-if="$store.state.id != 26 && $store.state.data.type != 30"
             class="share-tip"
             v-show="showShareTip"
             @click="showShareTip = !showShareTip">
             <img :src="`${$store.state.data.baseUrl}/share_tip.png`" alt="">
             <p>点击分享</p>
        </div>
        <div v-if="($store.state.id == 26 || $store.state.data.type == 30)"
             class="share-tip-26"
             v-show="showShareTip"
             @click="showShareTip = !showShareTip">
             <img class="tips" :src="`${$store.state.data.baseUrl}/share_tip.png`" alt="">
             <img class="close" :src="`${$store.state.data.baseUrl}/close.png`" alt="">
             <img class="share" :src="`${$store.state.data.baseUrl}/share.png`" alt="">
             <img class="save" :src="`${$store.state.data.baseUrl}/save.png`" alt="">
             <!-- <p class="save">长按保存图片</p> -->
        </div>
        <!-- <keep-alive> -->
          <chinaMap v-if="select !== 2" :type="select"></chinaMap>
          <statistics v-else></statistics>
        <!-- </keep-alive> -->
      </div>
      <keep-alive>
        <globe v-if="globe" v-on:detail="detail"></globe>
      </keep-alive>
    </div>
  </div>
</template>
<script>

import { setTimeout } from 'timers';
import Vconsole from 'vconsole';
import { Loading } from 'element-ui';
import globe from './components/globe.vue';
import chinaMap from './components/chinaMap.vue';
import statistics from './components/statistics.vue';
import { school, wxConfig } from '@/services/data';
// 通过局部引入方式引入 Element 的 Message 组件功能
// import SuperGif from '@/utils/libgif';

const wx = require('weixin-js-sdk');

let androidBGM = null;
export default {
  name: 'home',
  data() {
    return {
      // loaded: false, // 加载完成
      gifLoaded: false, // 加载完成
      gifFinish: false, // gif 播放完成
      school: false, // 是否有当前学校
      audio: null, // audio 实例对象
      playing: false, // audio 播放状态
      width: document.documentElement.clientWidth,
      height: document.documentElement.clientHeight,
      globe: false, // 展示3d地球
      select: this.$store.state.id == 26 || this.$store.state.id == 8 ? 2 : 1, // 0: 全球地图 1: 中国地图 2: 统计列表
      showShareTip: false, // 是否展示分享引导
      showYikeShareTip: false, // 广州医科大学分享引导
      showYikePoster: false, // 广州医科大学分享海报
    };
  },
  created() {
    console.log('created', this.$route.query);
    if (this.getUrlKey('openid')) {
      this.$store.commit('setDataOpenid', this.getUrlKey('openid'));
      console.log('当前用户身份信息', this.$store.state);
    }
    if (this.getUrlKey('nickname')) {
      this.$store.commit('setDataNickname', this.getUrlKey('nickname'));
      console.log('当前用户身份信息', this.$store.state);
    }
    // 拼接参数打开测试
    if (this.getUrlKey('test') === 'yangjunyan') {
      // eslint-disable-next-line no-unused-vars
      const vConsole = new Vconsole();
    }
    window.history.replaceState(null, null, window.location.href.split('?')[0]);
  },
  components: {
    globe,
    chinaMap,
    statistics,
  },
  methods: {
    // 获取学校信息
    getSchoolData() {
      // 获取学校资源
      school().then(({ data: { data = {} } }) => {
        console.log('获取学校资源', data, window.location.href);
        if (data.auth && !this.$store.state.data.openid) {
          const { href } = window.location;
          // location.protocol+'//' + location.host 或者 process.env.VUE_APP_BASE_API
          window.location.href = `${process.env.VUE_APP_BASE_API}/auth/wechat?id=${data.id}&type=map&to_url=${href}`;
        } else if (data.id) {
          if (data.auth) {
            console.log('当前用户身份信息', this.$store.state.data.openid);
            data.openid = this.$store.state.data.openid;
            data.nickname = this.$store.state.data.nickname;
          }
          if (!data.type) {
            data.type = data.id;
          }
          data.id = parseInt(data.id);
          this.$store.commit('setData', data);
          // eslint-disable-next-line no-nested-ternary
          document.title = this.$store.state.id == 8 ? '寻找北师大的你' : (this.$store.state.id == 26 ? 'CAUer，一起点亮全球!' : this.$store.state.data.title);
          this.loadImg(data.baseUrl);
          this.school = true;
          this.globe = true;
          this.weixinConfig();
        }
      });
    },

    // 获取url参数
    getUrlKey(name) {
      // eslint-disable-next-line
      return decodeURIComponent((new RegExp('[?|&]'+name+'='+'([^&;]+?)(&|#|;|$)').exec(location.href)||[,""])[1].replace(/\+/g,'%20'))||null;
    },

    // gif加载
    gifState() {
      console.log('gif加载状态改变');
      this.gifLoaded = true;
      setTimeout(() => {
        this.gifFinish = true;
      }, this.$store.state.data.gifTime * 1000);
    },

    // 点击播放
    play() {
      if (this.playing && this.$refs.audio && !this.isAndroid()) this.$refs.audio.play();
    },

    // 图片预加载
    loadImg(baseUrl) {
      const imgSrcArr = [
        'globe_button1.png',
        'globe_button2.png',
        'globe_button3.png',
        'globe_button4.png',
        'school_title.png',
        'bg1.png',
        'bg2.png',
        'bg3.png',
        'bg4.png',
        'statistics_bg.png',
      ];

      for (let i = 0; i < imgSrcArr.length; i += 1) {
        const img = new Image();
        img.src = `${baseUrl}/${imgSrcArr[i]}`;
        // img.onload = (e) => {
        //   console.log('img load', e);
        //   if (e.path[0].src.indexOf('welcome.gif') != -1) {
        //     this.gifState();
        //   }
        // };
        // img.onerror = (e) => {
        //   console.log('img error', e);
        //   if (e.path[0].src.indexOf('welcome.gif') != -1) {
        //     this.gifState();
        //   }
        // };
      }

      // 设置gif加载逻辑
      if (this.$store.state.data.gifTime) {
        const loadingInstance = Loading.service({ background: 'rgba(255, 255, 255, 0)' });
        const img = new Image();
        img.src = `${baseUrl}/welcome.gif`;
        img.onload = () => {
          loadingInstance.close();
          this.gifState();
        };
        img.onerror = () => {
          loadingInstance.close();
          this.gifState();
        };
      }
    },

    // 操作audio
    audioTap() {
      if (this.playing) {
        this.playing = false;
        if (!this.isAndroid()) this.$refs.audio.pause();
      } else {
        this.playing = true;
        if (!this.isAndroid()) this.$refs.audio.play();
      }
      if (this.isAndroid()) {
        androidBGM.toggleBGM();
      }
    },

    // 设置 微信 sdk
    async weixinConfig() {
      try {
        const { data: { data = {} } } = await wxConfig(window.location.href.split('#')[0]);
        console.log('微信签名', data, window.location.href);
        wx.config({
          // debug: this.isPc(), // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          debug: this.getUrlKey('test') === 'yangjunyan', // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          appId: data.appId, // 必填，公众号的唯一标识
          timestamp: data.timestamp, // 必填，生成签名的时间戳
          nonceStr: data.nonceStr, // 必填，生成签名的随机串
          signature: data.signature, // 必填，签名，见附录1
          jsApiList: data.jsApiList, // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
        // openTagList: ['wx-open-launch-weapp'],
        });

        wx.error((failMsg) => {
          console.log('设置 微信 sdk 报错', failMsg);
        });

        wx.ready(() => {
          console.log('设置 微信 sdk 成功', this.$store.state);
          if (!this.isAndroid() && this.$refs.audio && this.$store.state.id != 26) {
            this.$refs.audio.play()
              .then((res) => {
                this.playing = true;
                console.log('音频播放成功', res);
              })
              .catch((error) => {
                console.log('音频播放失败:', error);
              });
          }

          wx.updateAppMessageShareData({
            title: this.$store.state.data.total ? this.$store.state.data.userTitle : this.$store.state.data.title,
            desc: this.$store.state.data.desc,
            link: window.location.href.split('?')[0],
            imgUrl: `${this.$store.state.data.baseUrl}/logo.png`,
            success(res) {
              console.log('分享设置成功', res);
            },
            fail(res) {
              console.log('分享设置失败', res);
            },
          });
          wx.updateTimelineShareData({
            title: this.$store.state.data.total ? this.$store.state.data.userTitle : this.$store.state.data.title,
            link: window.location.href.split('?')[0],
            imgUrl: `${this.$store.state.data.baseUrl}/logo.png`,
            success(res) {
              console.log('朋友圈分享设置成功', res);
            },
            fail(res) {
              console.log('朋友圈分享设置失败', res);
            },
          });

          // wx.onMenuShareTimeline({
          //   title: this.$store.state.data.total ? this.$store.state.data.userTitle : this.$store.state.data.title, // 分享标题
          //   link: window.location.href.split('?')[0], // 分享链接，该链接域名或路径必须与当前页面对应的服务号JS安全域名一致
          //   imgUrl: `${this.$store.state.data.baseUrl}/logo.png`, // 分享图标
          //   success() {
          //   // 用户点击了分享后执行的回调函数
          //   },
          // });

          // wx.onMenuShareAppMessage({
          //   title: this.$store.state.data.total ? this.$store.state.data.userTitle : this.$store.state.data.title, // 分享标题
          //   desc: this.$store.state.data.desc, // 分享描述
          //   link: window.location.href.split('?')[0], // 分享链接，该链接域名或路径必须与当前页面对应的服务号JS安全域名一致
          //   imgUrl: `${this.$store.state.data.baseUrl}/logo.png`, // 分享图标
          //   success() {
          //     // 用户点击了分享后执行的回调函数
          //   },
          // });

          wx.hideMenuItems({
            menuList: ['menuItem:copyUrl', 'menuItem:originPage', 'menuItem:openWithQQBrowser', 'menuItem:openWithSafari', 'menuItem:share:email'], // 要隐藏的菜单项，只能隐藏“传播类”和“保护类”按钮，所有 menu 项见附录3
          });

          wx.miniProgram.getEnv((env) => {
            console.log('getEnv', env.miniprogram);
            if (env.miniprogram) {
              wx.miniProgram.postMessage({
                data: {
                  title: this.$store.state.data.total ? this.$store.state.data.userTitle : this.$store.state.data.title,
                  path: `/pages/web?url=${encodeURIComponent(window.location.href)}`,
                  imageUrl: `${this.$store.state.data.baseUrl}/mini_program_share_url.png`,
                },
              });
            } else {
              console.log('不在小程序内');
            }
          });
        });
        if (this.isAndroid() && this.$refs.audio) {
          this.androidBGM();
        }
      } catch (err) {
        setTimeout(() => {
          this.weixinConfig();
        }, 1000);
      }

      // document.addEventListener('WeixinOpenTagsError', (e) => {
      //   console.error('无法使用开放标签的错误原因', e.detail.errMsg); // 无法使用开放标签的错误原因，需回退兼容。仅无法使用开放标签，JS-SDK其他功能不受影响
      // });
    },

    // 安卓微信浏览器下 H5 自动播放背景音乐
    /* eslint-disable */
    androidBGM() {
      var self = this;
      function BGMAutoPlayMgr(url) {
        console.log('创建播放');
        this.audioContext = new (window.AudioContext || window.webkitAudioContext || window.mozAudioContext)();
        this.sourceNode = null;
        this.buffer = null;
        this.isPlayingBGM = false;
        this.toggleBGM = function () {
          if (typeof this.sourceNode == 'object') {
            if (this.isPlayingBGM) {
              this.sourceNode.stop();
              this.isPlayingBGM = false;
            } else {
              this._playSourceNode();
            }
          }
        };
        this._playSourceNode = function () {
          const { audioContext } = this;
          audioContext.resume();
          const _sourceNode = audioContext.createBufferSource();
          _sourceNode.buffer = this.buffer;
          _sourceNode.loop = true;
          _sourceNode.connect(audioContext.destination);
          _sourceNode.start(0);
          this.sourceNode = _sourceNode;
          this.isPlayingBGM = true;
        };
        let loadAndAutoPlay = (audioUrl) => {
          const { audioContext } = this;
          const xhr = new XMLHttpRequest();
          xhr.open('GET', audioUrl, true);
          xhr.responseType = 'arraybuffer';
          xhr.onreadystatechange = () => {
            if (xhr.status < 400 && xhr.status >= 200 && xhr.readyState === 4) {
              audioContext.decodeAudioData(xhr.response, (buffer) => {
                this.buffer = buffer;
                WeixinJSBridge.invoke('getNetworkType', {}, () => {
                  if (self.$store.state.id != 26) {
                    this._playSourceNode();
                  }
                });
              });
            }
          };
          xhr.send();
        };
        loadAndAutoPlay(url);
        loadAndAutoPlay = null;
      }
      androidBGM = new BGMAutoPlayMgr(`${this.$store.state.data.baseUrl}/bg_music.mp3`);
      // /* 测试地址 */ androidBGM = new BGMAutoPlayMgr("http://img.crossess.com/2022-08-29-17-34-11-630c88138f27e.mp3");
      if (this.$store.state.id != 26) {
        androidBGM.toggleBGM();
        this.playing = true;
      }
    },

    // 判断是否是 android 环境
    isAndroid() {
      const browser = {
        versions: (function IIFE() {
          const u = navigator.userAgent;
          // const app = navigator.appVersion;
          return { // 移动终端浏览器版本信息
            ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), // ios终端
            android: u.indexOf('Android') > -1 || u.indexOf('Linux') > -1, // android终端或uc浏览器 //u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; //android终端
            iPhone: u.indexOf('iPhone') > -1, // 是否为iPhone或者QQHD浏览器
            iPad: u.indexOf('iPad') > -1, // 是否iPad
          };
        }()),
      };
      // if (browser.versions.iPhone || browser.versions.iPad || browser.versions.ios) {
      //    return false;
      // }
      if (browser.versions.android) { return true; }
      return false;
    },

    // isPc() {
    //   const plat = navigator.platform;
    //   const win = plat.indexOf('Win') == 0;
    //   const mac = plat.indexOf('Mac') == 0;
    //   if (win || mac) {
    //     return true;
    //   }
    //   return false;
    // },

    // 3d地球进入地图
    detail() {
      console.log('进入详情');
      this.globe = false;
    },

    // 顶部选择按钮
    topSelect(e) {
      // console.log(e, e.target.innerText.replace(/[\r\n]/g, ''));
      switch (e.target.innerText.replace(/[\r\n]/g, '')) {
        case '全球地图':
          console.log('全球地图');
          this.select = 0;
          break;
        case '全国地图':
          console.log('全国地图');
          this.select = 1;
          break;
        case '统计':
          console.log('统计');
          this.select = 2;
          break;
        default:
          break;
      }
    },

    // 底部操作按钮
    backTap() {
      console.log('返回');
      if (this.$store.state.id == 32) {
        // 返回小程序  在小程序外，使用 wx-open-launch-weapp 标签跳转小程序
        wx.miniProgram.getEnv((env) => {
          console.log('getEnv', env.miniprogram);
          if (env.miniprogram) {
            wx.miniProgram.reLaunch({
              url: '/pkgXiaoQing/pages/index',
            })
          } else {
            console.log('不在小程序内');
            this.globe = true;
          }
        })
      } else {
        this.globe = true;
      }
    },

    // 分享操作
    shareTap() {
      console.log('分享', wx);
      this.showShareTip = !this.showShareTip
    },
  },
  computed: {
  },
  mounted() {
    this.getSchoolData();
    window.addEventListener('resize', (e) => {
      console.log('resize', e);
      this.width = document.documentElement.clientWidth;
      this.height = document.documentElement.clientHeight;
    });

    // 北师大单独设置移动端适配方式
    if (this.$store.state.data.type == 8) {
    // 设置 rem 函数
      const baseSize = 75;

      // 设置 rem 函数
      const setRem = () => {
      // 当前页面宽度相对于 750 宽的缩放比例，可根据自己需要修改。
        const scale1 = document.documentElement.clientHeight / 1334;
        const scale2 = document.documentElement.clientWidth / 750;
        const scale = (scale1 + scale2) / 2;
        // 设置页面根节点字体大小
        // rem会导致缩放到低于1px的元素时隐时现，解决办法：Math.min(scale, 2)指定最小转换像素，对于比较小的像素，不转换为 rem 或 vw
        document.documentElement.style.fontSize = `${baseSize * Math.min(scale, 2)}px`;
      };

      // 初始化
      setRem();
      // 改变窗口大小时重新设置 rem
      window.onresize = () => {
        setRem();
      };
    }

    // this.audio = document.getElementById('audio');
    // this.audio = this.$refs.audio;
    // libgif 操控gif
    // if (parseInt(this.$store.state.id, 10) === 8) {
    //   const gif = new SuperGif({
    //     loop_mode: false,
    //     gif: document.getElementById('gif'),
    //     on_end: (dom) => {
    //       console.log('gif 播放完成', dom);
    //       // eslint-disable-next-line no-unused-expressions
    //       document.getElementsByClassName('jsgif')[0] && document.getElementsByClassName('jsgif')[0].remove();
    //       this.gifFinish = true;
    //     },
    //   });
    //   gif.load(() => {
    //     setTimeout(() => {
    //       this.loaded = true;
    //     }, 1000);
    //     console.log('gif 加载完成');
    //   });
    // }
  },
};
</script>

<style lang="less" scoped>
// @scale: (100vw / 750);
.gif {
  width: 100vw;
  height: 100vh;
  object-fit: fill;
}
.audio {
  position: fixed;
  width: 50px;
  height: 50px;
  background-size: cover;
  background-size: cover;
  right: 20px;
  top: 20px;
  z-index: 999;
  animation: none;
  // background-image: url(https://mat1.gtimg.com/zj/lyen/zhengwu/xiguajie/imgs/music_pause.png);
}

.playing {
  // background-image: url(https://mat1.gtimg.com/zj/lyen/zhengwu/xiguajie/imgs/music.png);
  animation: audio 2s linear infinite;
}

.audio21 {
  position: fixed;
  z-index: 999;
  left: 20px;
  top: 20px;
  width: 80px;
  height: 80px;
}

.audio-bg {
  position: absolute;
  width: 100%;
  height: 100%;
}

@keyframes audio {
  0% {
      transform: rotate3d(0, 0, 1, -360deg);
  }
  50% {
      transform: rotate3d(0, 0, 1, -180deg);
  }
  100% {
      transform: rotate3d(0, 0, 1, 0deg);
  }
}

.globebg {
  position: absolute;
  z-index: -1;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background-size: cover;
}
.globebg-30 {
  object-fit: fill;
}
.main {
  position: absolute;
  z-index: 10;
  width: 100vw;
  height: 100vh;
  .topButton {
    // margin-top: 80px;
    width: 100%;
    height: 175px;
    display: flex;
    justify-content: center;
    div {
      position: relative;
      display: flex;
      justify-content: center;
      padding-top: 80px;
      padding-bottom: 20px;
      align-items: center;
      width: 226px;
      height: 75px;
      background-size: cover;
      font-size: 28px;
      font-family: HuXiaoBo-NanShen;
      font-weight: 400;
      color: #FFFFFF;
      img {
        position: absolute;
        width: 100%;
        height: 75px;
        z-index: -1;
      }
    }
  }
  .topButton30 {
    div {
      margin: 0 8px;
    }
  }
  .bottomButton {
    position: absolute;
    bottom: 115px;
    left: 0;
    width: 100vw;
    display: flex;
    justify-content: center;
    div {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      width: 226px;
      background-size: cover;
      font-size: 28px;
      font-family: HuXiaoBo-NanShen;
      font-weight: 400;
      color: #FFFFFF;
      .img {
        position: absolute;
        width: 226px;
        height: 75px;
        z-index: -1;
      }
      .beishida-img {
        width: 113px;
        height: 113px;
      }
      .beishida-title {
        margin-top: 32px;
        color: #DB9256;
      }
    }
    .share {
      margin-left: 94px;
    }
  }
  .bottomButton26 {
    position: absolute;
    bottom: 92px;
    left: 0;
    width: 100vw;
    display: flex;
    justify-content: center;
    div {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      width: 240px;
      height: 100px;
      .img {
        position: absolute;
        width: 240px;
        height: 100px;
        z-index: -1;
      }
      p {
        display: none;
      }
    }
    .share {
      margin-left: 42px;
    }
  }
  .bottomButton32 {
    position: absolute;
    bottom: 28px;
    left: 0;
    width: 100vw;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    div {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      width: 476px;
      height: 106px;
      position: relative;
      .img {
        position: absolute;
        width: 100%;
        height: 100%;
        z-index: -1;
      }
    }
    .back {
      margin-top: 16px;
    }
  }
  .share-tip {
    position: absolute;
    z-index: 1000;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.7);
    font-size: 33px;
    font-family: PingFang SC;
    font-weight: bold;
    color: #FFFFFF;
    text-shadow: 1px 1px 5px #fff;
    img {
      position: absolute;
      top: 50px;
      right: 50px;
      width: 175px;
      height: 175px;
    }
    p {
      position: absolute;
      top: 250px;
      right: 90px;
    }
  }

  .share-tip-26 {
    position: absolute;
    z-index: 1000;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.7);
    font-size: 33px;
    font-family: PingFang SC;
    font-weight: bold;
    color: #FFFFFF;
    text-shadow: 1px 1px 5px #fff;

    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .tips {
      position: absolute;
      width: 558px;
      height: 75px;
      top: 20px;
      right: 80px;
    }
    .close {
      margin-left: auto;
      margin-right: 55px;
      width: 56px;
      height: 56px;
    }
    .share {
      margin-top: 30px;
      width: 640px;
      height: 918px;
    }
    .save {
      margin-top: 49px;
      width: 261px;
      height: 40px;
    }
  }

  .yike-share-tip {
    position: absolute;
    z-index: 1000;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.7);
    font-size: 33px;
    font-family: PingFang SC;
    font-weight: bold;
    color: #FFFFFF;
    text-shadow: 1px 1px 5px #fff;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    img {
      width: 80vw;
      height: 80.84vw;
    }
    .yike-button {
      width: 100%;
      display: flex;
      .yike-poster {
        padding: 50px 0;
        width: 50%;
        text-align: center;
      }
    }
  }
}
</style>
